import { ChangeDetectionStrategy, Component, inject, Input, WritableSignal } from '@angular/core';

import { SearchSvgIconComponent } from '@components/svg-icons/search-svg-icon/search-svg-icon.component';
import { SpanishSvgIconComponent } from '@components/svg-icons/spanish-svg-icon/spanish-svg-icon.component';
import { LnNosotrosSvgIconComponent } from '@components/svg-icons/ln-nosotros-svg-icon/ln-nosotros-svg-icon.component';
import { FrameSvgIconComponent } from '@components/svg-icons/frame-svg-icon/frame-svg-icon.component';
import { LnMovilMenuSvgIconComponent } from '@components/svg-icons/ln-movil-menu-svg-icon/ln-movil-menu-svg-icon.component';
import { MainMenuButonComponent } from '@components/butons/main-menu-buton/main-menu-buton.component';
import { LnMovilMenuButtonComponent } from '@components/butons/ln-movil-menu-button/ln-movil-menu-button.component';
import { MainMenuShoppingCartButonComponent } from '@components/butons/ln-main-menu-shopping-cart-buton/main-menu-shopping-cart-buton.component';
import { ShoppingCartSvgIconComponent } from '@components/svg-icons/shopping-cart-svg-icon/shopping-cart-svg-icon.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { LanguageService } from '@core/services/language/language.service';
import { Languages } from '@enums/languages';
import { EnglishFagSvgIconComponent } from '@components/svg-icons/english-fag-svg-icon/english-fag-svg-icon.component';
import { MenuActions } from '../../../states/menu_actions';
import { DeviceScreenFamilyService } from '@core/services/device-screen-family/device-screen-family.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-main-menu',
  imports: [
    MainMenuButonComponent,
    FrameSvgIconComponent,
    SpanishSvgIconComponent,
    SearchSvgIconComponent,
    LnNosotrosSvgIconComponent,
    LnMovilMenuButtonComponent,
    LnMovilMenuSvgIconComponent,
    ShoppingCartSvgIconComponent,
    MainMenuShoppingCartButonComponent,
    SearchSvgIconComponent,
    SpanishSvgIconComponent,
    LnNosotrosSvgIconComponent,
    FrameSvgIconComponent,
    LnMovilMenuSvgIconComponent,
    MainMenuButonComponent,
    LnMovilMenuButtonComponent,
    MainMenuShoppingCartButonComponent,
    ShoppingCartSvgIconComponent,
    TranslocoPipe,
    EnglishFagSvgIconComponent,
    NgClass,
  ],
  templateUrl: './main-menu.component.html',
  styleUrl: './main-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnMainMenuComponent {
  private readonly TAG = 'LnMainMenuComponent';
  protected readonly Languages = Languages;
  protected language = inject(LanguageService);
  protected activeLanguage = this.language.activeLanguage;
  @Input({ required: true }) showSearchBarOnDemand!: WritableSignal<boolean>;
  menuActions = inject(MenuActions);
  private deviceScreenFamily = inject(DeviceScreenFamilyService);
  protected currentScreenSize = this.deviceScreenFamily.currentDeviceScreenFamily;

  constructor() {
    /* console.log(
      `${this.TAG} this.activeLanguage() ${this.activeLanguage()} (this.activeLanguage() === Languages.es) ${this.activeLanguage() === Languages.es}`
    ); */
  }
  toogleShowSearchBarOnDemand() {
    this.showSearchBarOnDemand.set(!this.showSearchBarOnDemand());
  }

  languageSwitcher() {
    console.log(
      `${this.TAG} this.activeLanguage() ${this.activeLanguage()} (this.activeLanguage() == Languages.es.valueOf()) ${this.activeLanguage() == Languages.es.valueOf()}`
    );
    if (this.activeLanguage() == Languages.es.valueOf()) {
      this.language.changeLanguage(Languages.en);
    } else {
      this.language.changeLanguage(Languages.es);
    }
  }

  navigateToAboutUsPage(): void {
    this.menuActions.navigateToAboutUsPage();
  }

  navigateToServicesPage(): void {
    this.menuActions.navigateToServices();
  }

  navigateToLunaNuevaBlog() {
    this.menuActions.navigateToBlog();
  }
}
